(function () {
  var menusInitialized = false;
  var megaPromise = null;
  var CACHE_KEY = 'ep-mega-menu-lazy-v1';
  var CACHE_MS = 30 * 60 * 1000;

  function sectionUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + '?section_id=mega-menu-lazy';
  }

  function getCachedHtml() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.html || Date.now() - data.t > CACHE_MS) return null;
      return data.html;
    } catch (e) {
      return null;
    }
  }

  function setCachedHtml(html) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), html: html }));
    } catch (e) {}
  }

  function markReady() {
    var menu = document.querySelector('.inline-menu');
    if (menu) menu.classList.add('mega-ready');
    document.querySelectorAll('.inline-mega.mega-loading').forEach(function (el) {
      el.classList.remove('mega-loading');
      var tip = el.querySelector('.mega-loading-tip');
      if (tip) tip.remove();
    });
  }

  function showLoadingFor(target) {
    var item = target && target.closest ? target.closest('.inline-menu-item') : null;
    var mega = item ? item.querySelector('.inline-mega[data-mega-slot]') : null;
    if (!mega || mega.querySelector('.inline-mega-inner')) return;
    mega.classList.add('mega-loading');
    if (!mega.querySelector('.mega-loading-tip')) {
      mega.innerHTML = '<div class="mega-loading-tip" aria-hidden="true"></div>';
    }
  }

  function applyHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var injected = 0;
    doc.querySelectorAll('.inline-mega[data-mega-slot]').forEach(function (src) {
      if (!src.querySelector('.inline-mega-inner')) return;
      var slot = src.getAttribute('data-mega-slot');
      var dest = document.querySelector('.inline-menu .inline-mega[data-mega-slot="' + slot + '"]');
      if (!dest) return;
      dest.classList.remove('mega-loading');
      dest.innerHTML = src.innerHTML;
      var label = src.getAttribute('aria-label');
      if (label) dest.setAttribute('aria-label', label);
      injected += 1;
    });
    if (injected) {
      menusInitialized = false;
      initNestedMenus();
      markReady();
      if (typeof window.fillReviewsCount === 'function') window.fillReviewsCount();
    }
    return injected;
  }

  function fetchHtml() {
    if (window.__megaMenuPrefetch) {
      var early = window.__megaMenuPrefetch;
      window.__megaMenuPrefetch = null;
      return Promise.resolve(early).then(function (html) {
        if (typeof html === 'string' && html.indexOf('inline-mega-inner') !== -1) return html;
        return fetch(sectionUrl(), { credentials: 'same-origin' }).then(function (r) { return r.text(); });
      });
    }
    return fetch(sectionUrl(), { credentials: 'same-origin' }).then(function (r) { return r.text(); });
  }

  function loadMegaPanels() {
    if (megaPromise) return megaPromise;

    if (document.querySelector('.inline-menu .inline-mega[data-mega-slot] .inline-mega-inner')) {
      megaPromise = Promise.resolve().then(function () {
        menusInitialized = false;
        initNestedMenus();
        markReady();
        if (typeof window.fillReviewsCount === 'function') window.fillReviewsCount();
      });
      return megaPromise;
    }

    var cached = getCachedHtml();
    if (cached) {
      applyHtml(cached);
    }

    megaPromise = fetchHtml()
      .then(function (html) {
        if (typeof html !== 'string' || html.indexOf('inline-mega-inner') === -1) {
          throw new Error('empty mega menu');
        }
        setCachedHtml(html);
        applyHtml(html);
      })
      .catch(function () {
        megaPromise = null;
      });

    return megaPromise;
  }

  function initNestedMenus() {
    if (menusInitialized) return;
    if (!document.querySelector('.inline-mega .has-nested-items, .inline-mega .has-default-menu')) return;
    menusInitialized = true;

    var nestedTriggers = document.querySelectorAll('.has-nested-items');
    var defaultTriggers = document.querySelectorAll('.has-default-menu');
    var firstActiveTrigger = null;

    nestedTriggers.forEach(function (trigger, index) {
      var targetId = trigger.getAttribute('data-menu-target');
      var nestedContent = document.querySelector('[data-nested-content="' + targetId + '"]');
      var inlineMega = trigger.closest('.inline-mega');
      var defaultContent = inlineMega ? inlineMega.querySelector('.nested-menu-default') : null;
      if (!nestedContent) return;

      if ((trigger.classList.contains('active') || index === 0) && !firstActiveTrigger) {
        firstActiveTrigger = { trigger: trigger, nestedContent: nestedContent, defaultContent: defaultContent, type: 'nested' };
      }

      trigger.addEventListener('mouseenter', function () {
        if (!inlineMega) return;
        inlineMega.querySelectorAll('.has-nested-items, .has-default-menu').forEach(function (t) { t.classList.remove('active'); });
        inlineMega.querySelectorAll('.nested-menu-content').forEach(function (content) { content.classList.remove('active'); });
        if (defaultContent) defaultContent.style.display = 'none';
        trigger.classList.add('active');
        nestedContent.classList.add('active');
        var reviews = inlineMega.querySelector('.mega-menu-reviews');
        if (reviews) nestedContent.appendChild(reviews);
      });

      nestedContent.addEventListener('mouseenter', function () {
        trigger.classList.add('active');
        nestedContent.classList.add('active');
      });

      nestedContent.addEventListener('mouseleave', function () {
        if (!firstActiveTrigger || trigger !== firstActiveTrigger.trigger) {
          trigger.classList.remove('active');
          nestedContent.classList.remove('active');
          if (defaultContent) defaultContent.style.display = 'block';
          var reviews = inlineMega.querySelector('.mega-menu-reviews');
          var display = inlineMega.querySelector('.nested-menu-display');
          if (reviews && display) display.insertBefore(reviews, display.querySelector('.nested-menu-content'));
        }
      });
    });

    defaultTriggers.forEach(function (trigger, index) {
      var inlineMega = trigger.closest('.inline-mega');
      var defaultContent = inlineMega ? inlineMega.querySelector('.nested-menu-default') : null;
      if (!defaultContent) return;
      if ((trigger.classList.contains('active') || (index === 0 && nestedTriggers.length === 0)) && !firstActiveTrigger) {
        firstActiveTrigger = { trigger: trigger, defaultContent: defaultContent, type: 'default' };
      }
      trigger.addEventListener('mouseenter', function () {
        if (!inlineMega) return;
        inlineMega.querySelectorAll('.has-nested-items, .has-default-menu').forEach(function (t) { t.classList.remove('active'); });
        inlineMega.querySelectorAll('.nested-menu-content').forEach(function (content) { content.classList.remove('active'); });
        trigger.classList.add('active');
        defaultContent.style.display = 'block';
        var reviews = inlineMega.querySelector('.mega-menu-reviews');
        var display = inlineMega.querySelector('.nested-menu-display');
        if (reviews && display) display.insertBefore(reviews, display.querySelector('.nested-menu-content'));
      });
    });

    if (firstActiveTrigger) {
      var trigger = firstActiveTrigger.trigger;
      var nestedContent = firstActiveTrigger.nestedContent;
      var defaultContent = firstActiveTrigger.defaultContent;
      var type = firstActiveTrigger.type;
      trigger.classList.add('active');
      if (type === 'nested' && nestedContent) {
        nestedContent.classList.add('active');
        if (defaultContent) defaultContent.style.display = 'none';
        var mega = trigger.closest('.inline-mega');
        var reviews = mega ? mega.querySelector('.mega-menu-reviews') : null;
        if (reviews) nestedContent.appendChild(reviews);
      } else if (type === 'default' && defaultContent) {
        defaultContent.style.display = 'block';
      }
    }
  }

  function onMenuIntent(e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.inline-menu, .header-mega-menu-div, .header')) return;
    if (e.target.closest('.inline-menu-item')) showLoadingFor(e.target);
    loadMegaPanels();
  }

  document.addEventListener('pointerover', onMenuIntent, true);
  document.addEventListener('focusin', onMenuIntent, true);

  if (document.querySelector('.inline-mega .inline-mega-inner')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initNestedMenus, { once: true });
    } else {
      initNestedMenus();
    }
    markReady();
  } else if (document.querySelector('.inline-mega[data-mega-slot]')) {
    // Start immediately — do not wait for idle.
    loadMegaPanels();
  }

  document.addEventListener('shopify:section:load', function () {
    menusInitialized = false;
    megaPromise = null;
    initNestedMenus();
  });
})();
